<template>
  <v-container xs12 fluid class="pt-0">
    <v-card class="pa-2 card-r pb-4 shadow-1">
      <v-toolbar class="primary darken-2 card-r pl-3 text-white">
        <div class="text-xs-left f-20">Payment Withdraw Request</div>
        <!--<div class="text-xs-left f-20">Total Earnings </div>-->
      </v-toolbar>
      <v-container fluid grid-list-xl class="pa-0 mt-2">
        <v-layout row wrap class="Content3 text-xs-center pa-0">
          <!--<v-flex d-flex lg4 sm6 xs12>-->
            <!--<v-card class="card-r no-shadow green accent-4 white&#45;&#45;text pa-3 topborder" flat xs12 sm6>-->
              <!--<br>-->
              <!--<v-icon class="white&#45;&#45;text">fas fa-credit-card</v-icon>-->
              <!--<p class="mt-0 mb-0 text-xs-center font-weight-medium subheading font-weight-light">Total Earnings </p>-->
              <!--<span class="display-0.75 text-xs-center headline font-weight-bold">$ 50,000.00 </span>-->
            <!--</v-card>-->
          <!--</v-flex>-->

          <!--<v-flex d-flex lg4 sm6 xs12>-->
            <!--<v-card class="card-r no-shadow">-->
              <!--<v-card-title>-->
                <!--<v-flex xs6 class="text-md-center">-->
                  <!--<v-icon>fas fa-credit-card</v-icon>-->

                  <!--<p class="disable-1">Total Earnings</p>-->
                <!--</v-flex>-->
                <!--<v-flex xs6 class="text-md-center conPar">-->
                  <!--<p>5000$</p>-->
                <!--</v-flex>-->
              <!--</v-card-title>-->
            <!--</v-card>-->
          <!--</v-flex>-->

          <v-flex d-flex lg12 sm12 xs12>

            <v-card class="white pl-3 pr-3 pt-3 pb-0 card-r no-shadow">
              <!--<div class="f-15 pb-2 font-weight-bold text-capitalize textColor text-xs-left">Payment Withdraw Request</div>-->
              <v-container fluid grid-list-xl class="pa-0">
                <v-layout row wrap class="">
                  <v-flex d-flex lg4 xs12 class="">
                    <v-text-field
                      solo
                      disabled
                      prefix="$"
                      prepend-icon="fa-credit-card"
                      label="Total balance"
                      v-model="totalEarning.total_driver_have_to_pay"
                    >
                    </v-text-field>
                  </v-flex>
                <!--<v-divider inset vertical></v-divider>-->
                  <v-flex d-flex lg4 xs12>
                    <v-text-field solo
                    prefix="$"
                    label="Request amount"
                    prepend-icon="fa-credit-card"
                    placeholder="Requesting amount"
                    v-model="amount"
                    v-bind:messages="errormessage">
                  </v-text-field>
                </v-flex>

                  <v-flex d-flex lg4 xs12 class="pt-2 mb-2">
                    <v-btn flat class="shadow-1 w-100 card-r mt-1 h-50p white darken-2 text-primary font-weight-bold" v-on:click="withdrawalAmount">Request Money</v-btn>
                  <!--<v-btn disabled larg depressed class="no-shadow card-r" color="primary">Widthraw</v-btn>-->
                </v-flex>
                </v-layout>
              </v-container>
            </v-card>

          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
      <v-card class="pa-2 card-r pb-4 shadow-1 mt-3">

      <v-layout>
        <v-flex>
          <v-toolbar class="primary darken-2 card-r pl-3 text-white">
            <div class="text-xs-left f-20">Earnings Statement</div>
          </v-toolbar>
          <!--<div class="f-25 text-xs-center font-weight-bold pb-3 textColor"></div>-->
      <v-card class="grey lighten-4 mt-3 pa-2 shadow-1">
        <v-data-table :headers="headers" :items="earningStatementData" class="mt-2 red laptop-data-table">

          <template slot="items" slot-scope="props">
            <td>{{ props.item.date }}</td>
            <td>{{ props.item.payee_name }}</td>
            <td>{{ props.item.payer_name }}</td>
            <td>{{ props.item.deposit }}</td>
            <td>{{ props.item.withdraw }}</td>
            <td>{{ props.item.balance }}</td>
          </template>
        </v-data-table>
        <v-data-table  :items="earningStatementData" class="  red mt-2 mobile-data-table">

          <template slot="items" slot-scope="props">
            <v-card class="mb-3 grey lighten-3 pa-3 no-shadow card-r">
              <v-flex><span class="font-weight-bold mr-1">Date : </span>  {{ props.item.date }}</v-flex>
              <v-flex><span class="font-weight-bold mr-1">Payee Name :  </span>  {{ props.item.payee_name }}</v-flex>
              <v-flex><span class="font-weight-bold mr-1">Payer Name : </span>   {{ props.item.payer_name }}</v-flex>
              <v-flex><span class="font-weight-bold mr-1">Deposit : </span>  {{ props.item.deposit }}</v-flex>
              <v-flex><span class="font-weight-bold mr-1">Withdraw :   </span>{{ props.item.withdraw }}</v-flex>
              <v-flex><span class="font-weight-bold mr-1">Balance :  </span> {{ props.item.balance }}</v-flex>
              <!-- <v-divider></v-divider> -->
            </v-card>
          </template>
        </v-data-table>
      </v-card>
        </v-flex>

      </v-layout>
      </v-card>
    </v-container>
    <!--<add-new-student/>-->
</template>

<script>
/* eslint-disable */
    import {mapState } from 'vuex'
  export default {
    name: "Students",
    data() {
      return {
        headers: [
          {text: "DATE", value: "Date"},
          { text: "PAYEE", value: "payee" },
          { text: "PAYER", value: "payer" },
          { text: "DEPOSIT", value: "deposit" },
          { text: "WITHDRAW", value: "withdraw" },
          { text: "BALANCE", value: "balance" }
        ],
        amount: '',
          errormessage: ""
//        earningData:'',
//        totalEarning:''
      };
    },
    created: function () {
      Store.dispatch('getAllEarnings');
      Store.dispatch('getTotalEarning');
    },

    methods: {
      withdrawalAmount: function() {
        if(parseInt(this.totalEarning.total_income_from_students) >= parseInt(this.amount) && this.amount !== '' && parseInt(this.amount) > 0) {
          Store.dispatch('withdrawalRequest', this.amount);
          this.amount = '';
            this.errormessage = "<span style='color: green'>Withdraw Request has been successfully sent<span>";
        } else {
            this.errormessage= "<span style='color: red'>You don't have sufficient balance to withdraw<span>";
        }
          setTimeout(() => {
              this.errormessage=''
          }, 1500);
      }
    },
    components: {
    },
      computed:{
          ...mapState({
              earningStatementData:"earningStatementData",
              totalEarning:"totalEarning",
          }),
      }
  };
</script>
<style>
 @media (min-width: 1281px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Laptops, Desktops
      ##Screen = B/w 1025px to 1280px
    */

    @media (min-width: 1025px) and (max-width: 1280px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Tablets, Ipads (portrait)
      ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Tablets, Ipads (landscape)
      ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          .mobile-data-table{
              display: none
          }
          .laptop-data-table{
              display: block
          }
    }

    /*
      ##Device = Low Resolution Tablets, Mobiles (Landscape)
      ##Screen = B/w 481px to 767px
    */

    @media (min-width: 481px) and (max-width: 767px) {
          .mobile-data-table{
              display: block
          }
          .laptop-data-table{
              display: none
          }
    }

    /*
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */

    @media (min-width: 320px) and (max-width: 480px) {
          .mobile-data-table{
              display: block
          }
          .laptop-data-table{
              display: none
          }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/TotalEarnings.vue